var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C20 2.79086 21.7909 1 24 1H35V35H24C21.7909 35 20 33.2091 20 31V5Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 35C23.7333 35 23.4735 34.9659 23.2238 34.9013L23.2177 34.9322C23.4718 34.9768 23.7332 35 24 35ZM21.7353 34.3894L21.8759 34.1794C21.5146 33.8637 21.2088 33.4694 20.9778 33.0189L20.5053 33.3352C20.8474 33.7564 21.2641 34.1145 21.7353 34.3894ZM19.7072 31.8536L20.5514 31.6866C20.5176 31.4635 20.5 31.2341 20.5 31V30.0714H19.5V30.5C19.5 30.669 19.5093 30.8358 19.5275 31C19.56 31.294 19.6208 31.5795 19.7072 31.8536ZM19.5 28.2143H20.5V26.3571H19.5V28.2143ZM19.5 24.5H20.5V22.6429H19.5V24.5ZM19.5 20.7857H20.5V18.9286H19.5V20.7857ZM19.5 17.0714H20.5V15.2143H19.5V17.0714ZM19.5 13.3571H20.5V11.5H19.5V13.3571ZM19.5 9.64286H20.5V7.78571H19.5V9.64286ZM19.5 5.92857H20.5V5C20.5 4.76588 20.5176 4.53646 20.5514 4.31337L19.7072 4.14636C19.6208 4.42051 19.56 4.70599 19.5275 5C19.5093 5.16417 19.5 5.331 19.5 5.5V5.92857ZM20.5053 2.66478L20.9778 2.98113C21.2088 2.5306 21.5146 2.13631 21.8759 1.82061L21.7353 1.61059C21.2641 1.88553 20.8474 2.24363 20.5053 2.66478ZM23.2238 1.09871C23.4735 1.0341 23.7333 1 24 1C23.7332 1 23.4718 1.02322 23.2177 1.06776L23.2238 1.09871Z",
    fill: "#2196F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 4,
    stroke: "#2196F3",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtl);
export default __webpack_public_path__ + "static/media/rtl.7acbc805614a32756e0b1bb5cb970203.svg";
export { ForwardRef as ReactComponent };